import { render, staticRenderFns } from "./event-detail.vue?vue&type=template&id=4d0701de&scoped=true"
import script from "./event-detail.vue?vue&type=script&lang=js"
export * from "./event-detail.vue?vue&type=script&lang=js"
import style0 from "./event-detail.vue?vue&type=style&index=0&id=4d0701de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0701de",
  null
  
)

export default component.exports